import Edit from '@mdi/svg/svg/pencil.svg?react';
import isFunction from 'lodash/isFunction';
import React, { memo, useState } from 'react';
import { MODAL_CONTENT_TYPE } from '../../constants';
import { Button } from '../Button';
import { MDIIcon } from '../MDIIcon';
import { Modal } from '../Modal';
import { Popover } from '../Popover';
import { type TableActionProps } from './DataTable.types';

const TableAction: React.FC<TableActionProps> = memo((props) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const {
    action,
    data,
    icon = <MDIIcon icon={Edit} size={16} />,
    id,
    index,
    isPopoverOverlayVisible = true,
    modalRenderer,
    modalStyle,
    modalClass,
    popoverRenderer,
    title,
  } = props;

  const actionHandler = () => {
    setIsPopoverOpen(true);
    action?.({ data, index });
  };

  const closePopover = () => {
    setIsPopoverOpen(false);
  };

  const buttonId = `table-action-${id}`;
  const realModalRenderer = isFunction(modalRenderer) ? modalRenderer(data) : modalRenderer;
  const realPopoverRenderer = isFunction(popoverRenderer) ? popoverRenderer(data) : popoverRenderer;

  return (
    <span className="table-action-wrapper">
      <Button
        className="table-action"
        dataTestId={title}
        icon={isFunction(icon) ? icon(data) : icon}
        iconOnly={true}
        id={buttonId}
        onClick={actionHandler}
        tooltip={isFunction(title) ? title(data) : title}
        tooltipStyle={{ wordBreak: 'normal' }}
        type="clear"
      />
      {!!realPopoverRenderer && (
        <Popover
          className="table-action-popover"
          horizontalPosition="left"
          isOverlayVisible={isPopoverOverlayVisible}
          isOpen={isPopoverOpen}
          onClose={closePopover}
          parent={`#${buttonId}`}
          verticalPosition="center"
        >
          {isPopoverOpen && realPopoverRenderer}
        </Popover>
      )}
      {!!realModalRenderer && (
        <Modal
          className={modalClass}
          isOpen={isPopoverOpen}
          onClose={closePopover}
          colorMode="dark"
          title={`${data.title} - ${data.subtitle}`}
          type={modalStyle}
          contentType={MODAL_CONTENT_TYPE.TABLE}
        >
          {isPopoverOpen && realModalRenderer}
        </Modal>
      )}
    </span>
  );
});

export default TableAction;
TableAction.displayName = 'TableAction';
